import React, { useEffect, useState } from "react";
import useShowAlert from "../../../utils/AlertUtiles";
import checkNetworkStatus from "../../common/networkStatus/CheckNetworkStatus";
import handleError from "../../../constant/handleError";
import { CircularProgress } from "@mui/material";
import axiosInstance from "../../../utils/AxiosInstance";
import { capitalizeFirstLetter } from "../../../utils/helper";

function AssignFieldOfficer({
  onClose,
  loading,
  name,
  isSelectedData,
  setSelectedData,
  setLoading,
  setBooking,
}) {
  const [isGLData, setGLData] = useState([]);
  const [selectedGL, setSelectedGL] = useState(null);
  const [filteredGLData, setFilteredGLData] = useState([]);
  const [searchText, setSearchText] = useState("");
  const showAlert = useShowAlert();
  const [isLoadingMore, setIsLoadingMore] = useState(false);
  const [totalItem, setTotalItems] = useState(0);

  const handleGLData = async (loadMore = false) => {
    if (!isSelectedData?.pincode) {
      showAlert(
        "error",
        "Booking Pincode not found. Cannot fetch Field Officers."
      );
      return;
    }

    if (!loadMore) {
      setLoading((prev) => ({
        ...prev,
        assignGLList: true,
      }));
    } else {
      setIsLoadingMore(true);
    }

    checkNetworkStatus();

    try {
      const response = await axiosInstance.get(
        "partnerauth/admin/list-fieldofficer"
      );

      if (
        response?.data?.status &&
        response?.data?.results?.length > 0
      ) {
        const newResults = response.data.results;

        if (loadMore) {
          setGLData((prev) => [...prev, ...newResults]);
          setFilteredGLData((prev) => [...prev, ...newResults]);
        } else {
          setGLData(newResults);
          setFilteredGLData(newResults);
        }
      }

      setTotalItems(response?.data?.totalItems || 0);
    } catch (error) {
      handleError(error, showAlert);
    } finally {
      setLoading((prev) => ({
        ...prev,
        assignGLList: false,
      }));

      setIsLoadingMore(false);
    }
  };

  const handleAssign = async () => {
    setLoading((prev) => ({
      ...prev,
      assignGLBtn: true,
    }));

    checkNetworkStatus();  
    try {
      const response = await axiosInstance.patch(
        `farmerbooking/admin/${isSelectedData._id}/assign-fo/${selectedGL._id}`
      );

      showAlert("success", response.data.message);
const updatedBookingData = response.data.results;
const newHistoryEntry = {
  bookingTracking:updatedBookingData.lastStatus,
  time: updatedBookingData.updatedAt,
  entryBy: "ADMIN"
};

      setSelectedData((prevSelected) => ({
        ...prevSelected,
          bookingStatusHistory: [
    ...(prevSelected?.bookingStatusHistory || []),

    newHistoryEntry
  ],
        assignedToFieldOfficer: {
          _id: updatedBookingData?.assignedToFieldOfficer?._id,
          mobileNumber: selectedGL?.mobileNumber,
          fullName: selectedGL?.name,
          lastStatus:updatedBookingData?.lastStatus,
          role: selectedGL?.role,
          updatedAt:updatedBookingData?.updatedAt
        },
      }));

      setBooking((prevBookings) => {
        return prevBookings.map((booking) => {
          if (booking._id === isSelectedData._id) {
            return {
              ...booking,
              assignedTo: {
                _id: selectedGL?._id,
                mobileNumber: selectedGL?.mobileNumber,
                fullName: selectedGL?.name,
                role: selectedGL?.role,
              },
            };
          }

          return booking;
        });
      });

      onClose();
    } catch (error) {
      handleError(error, showAlert);
    } finally {
      setLoading((prev) => ({
        ...prev,
        assignGLBtn: false,
      }));
    }
  };

  useEffect(() => {
    handleGLData();
  }, []);

  const handleSearch = (value) => {
    setSearchText(value);

    if (!value.trim()) {
      setFilteredGLData(isGLData);
      return;
    }

    const filtered = isGLData.filter((item) =>
      (item?.mobileNumber || "")
        .toString()
        .includes(value)
    );

    setFilteredGLData(filtered);
  };

  const handleLoadMore = () => {
    handleGLData(true);
  };

  return (
    <>
      <div className="modal-backdrop show"></div>

      <div
        className="modal show d-block"
        id="ViewPartnerModal"
        tabIndex="-1"
        aria-modal="true"
        role="dialog"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content ">
            <div className="modal-header border-bottom-0 py-3">
              <h6 className="modal-title fw-semibold">
                {name}:{" "}
                <span className="text-capitalize">
                  {isSelectedData?.pincode ||
                    isSelectedData?.bookingNumber}
                </span>
              </h6>

              <button
                type="button"
                className="btn-close border"
                onClick={onClose}
              ></button>
            </div>

            <div className="modal-body">
              {/* Search */}
              <div className="input-group mb-3">
                <input
                  type="text"
                  className="form-control"
                  maxLength={10}
                  placeholder="Search by mobile number..."
                  value={searchText}
                  onChange={(e) => {
                    const onlyNumbers = e.target.value.replace(
                      /\D/g,
                      ""
                    );

                    handleSearch(onlyNumbers);
                  }}
                />

                <button className="input-group-text bg-white">
                  <i className="bx bx-search"></i>
                </button>
              </div>

              {/* Count */}
              <div className="d-flex justify-content-between align-items-center mb-2">
                <h6 className="mb-0 font-12 ms-auto text-muted fw-bold">
                  Showing {filteredGLData.length} / {isGLData.length}
                </h6>
              </div>

              {/* List */}
              <div
                className={`${
                  loading.assignGLList
                    ? ""
                    : "list-group border rounded-4  overflow-auto"
                }`}
                  style={{
    maxHeight: "350px",
  }}
              >
                {loading.assignGLList ? (
                  <div className="text-center mt-3">
                    <CircularProgress
                      size={22}
                      className="text-green border-none"
                    />
                  </div>
                ) : isGLData.length === 0 ? (
                  <p className="text-center py-3 mb-0">
                    Field Officer data not found.
                  </p>
                ) : (
                  filteredGLData.map((gl) => (
                    <div
                      key={gl._id}
                     className={`list-group-item d-flex justify-content-between align-items-start 
                    ${selectedGL?._id === gl._id ? "active" : ""}`}
                      onClick={() => {
                        setSearchText("");
                        setSelectedGL(gl);
                      }}
                      style={{
                        cursor: "pointer",
                        padding: "12px",
                        transition: "0.2s",
                      }}
                    >
                        <div className={selectedGL?._id === gl._id ? "text-success font-12" : "text-muted font-12"} style={{ flex: 1 }}>
                        <div className="d-flex justify-content-between align-items-center">
                          <a
                            href={`tel:+91${gl?.mobileNumber}`}
                            className="text-black text-decoration-none"
                          >
                            <strong>{gl?.mobileNumber}</strong>
                          </a>

                         
                        </div>
                      <div className="d-flex justify-content-between align-items-center w-100">
                                              <p className="mb-0 mt-1">
                                                Name:{" "}
                                                <strong className="">
                                                  {capitalizeFirstLetter(gl?.name) || "-"}
                                                </strong>
                                              </p>
                                                {selectedGL?._id === gl._id && (
                                          <i className="bx bx-check-circle fs-6  text-success ms-2"></i>
                                        )}
                      </div>
                      </div>
                    </div>
                  ))
                )}
              </div>

              {/* Load More */}
              {totalItem > 10 &&
                filteredGLData.length < totalItem && (
                  <div className="text-center mt-3">
                    <button
                      onClick={handleLoadMore}
                      disabled={isLoadingMore}
                      className="btn btn-primary rounded-pill px-4"
                    >
                      {isLoadingMore ? (
                        <>
                          <span className="spinner-border spinner-border-sm me-2"></span>
                          Loading...
                        </>
                      ) : (
                        "Load More"
                      )}
                    </button>
                  </div>
                )}
            </div>

            <div className="modal-footer border-0 pt-0">
              <button
                type="button"
                className="btn btn-outline-secondary px-3"
                onClick={onClose}
              >
                Close
              </button>

              {loading.assignGLBtn ? (
                <button
                  className="btn btn-primary pb-0 text-right"
                  disabled
                >
                  <CircularProgress
                    size={20}
                    className="text-white"
                  />
                </button>
              ) : (
                <button
                  type="button"
                  className="btn btn-primary "
                  disabled={!selectedGL}
                  onClick={handleAssign}
                >
                  <i className="bx bx-check me-1"></i>
                  Assign
                </button>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default AssignFieldOfficer;